import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import { getlang, setlang } from 'src/helper/getlang'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'
import langM from './lang'
import score from 'src/helper/score'
import Toast from 'src/component/Toast'
import { jumpToUser } from 'src/helper/webviewFun'

import CountDown from './countdown'

@inject('store')
@observer


export default class WeekStar extends React.Component {
  constructor(props) {
    super(props)
    this.rechargeStore = this.props.store.register('activity/recharge')
  }
  state = {
    lang: langM.en,
    language: 'en',
    ruleStatus: false,
    time: 0,
    toastContent: '',
    getTime: 0,
    okSuss:{
      en:'Received',
      ar:'تم الإستلام',
      tr:'Alındı',
    },
    errSuss:{
      en:'Get failed',
      ar:'فشل',
      tr:'Alma Başarısız',
    }
  }

  componentDidMount() {
    this.$logEvent("benefit_main_screen")
  }

  async componentWillMount() {
    let { language } = this.props.location.query
    language =await getlang(language)
    if (language == 'tr') {
      setDocumentTitle('Çekim Bonusu')
    }else if (language == 'ar') {
      setDocumentTitle('جوائز الشحن')
    }else{
      setDocumentTitle('Recharge Benefit')
    }
    this.setState({
      lang: setlang(language, langM),
      language: language,
    })
    let uid = await setUidToken(this.props.location.query)
    await this.RunOnStart(uid)
  }

  async RunOnStart(uid) {
    let res = await this.rechargeStore.rechargeRewardList({}, this.state.lang)
    if (res.leftTimestamp && res.leftTimestamp > 0) {
      // this.countDown(res.leftTimestamp)
      this.setState({
        getTime: res.leftTimestamp
      })
    }
  }

  hideRule = async (status) => {
    if (status) {
      this.$logEvent("benefit_rule")
    }
    this.setState({
      ruleStatus: status
    })
  }

  getCharge = async (id) => {
    console.log('id', id)
    if (id == 1) {
      this.$logEvent("benefit_daily_10$")
    }
    if (id == 2) {
      this.$logEvent("benefit_daily_20$")
    }
    if (id == 3) {
      this.$logEvent("benefit_daily_30$")
    }
    if (id == 4) {
      this.$logEvent("benefit_daily_50$")
    }
    if (id == 5) {
      this.$logEvent("benefit_daily_100$")
    }
    if (id == 6) {
      this.$logEvent("benefit_month_150$")
    }
    if (id == 7) {
      this.$logEvent("benefit_month_500$")
    }
    if (id == 8) {
      this.$logEvent("benefit_month_1000$")
    }
    if (id == 9) {
      this.$logEvent("benefit_month_2000$")
    }
    if (id == 10) {
      this.$logEvent("benefit_month_4000$")
    }
    if (id == 11) {
      this.$logEvent("benefit_month_10000$")
    }
    if (id == 12) {
      this.$logEvent("benefit_month_20000$")
    }
    if (id == 13) {
      this.$logEvent("benefit_month_30000$")
    }
    if (id == 14) {
      this.$logEvent("benefit_month_40000$")
    }
    if (id == 15) {
      this.$logEvent("benefit_month_50000$")
    }
    let { language, okSuss, errSuss } = this.state
    let result = await this.rechargeStore.getCharge(id)
    if (result == true) {
      this.setState({
        toastContent: okSuss[language]
      })
    } else {
      this.setState({
        toastContent: errSuss[language]
      })
    }
    this.refs.toast.hideRule(true)
  }


  // 倒计时功能
  // countDown = (times) => {
  //   var timer = null
  //   timer = setInterval(
  //     function () {
  //       var day = 0,
  //         hour = 0,
  //         minute = 0,
  //         second = 0
  //       if (times > 0) {
  //         day = Math.floor(times / (60 * 60 * 24))
  //         hour = Math.floor(times / (60 * 60)) - day * 24
  //         minute = Math.floor(times / 60) - day * 24 * 60 - hour * 60
  //         second = Math.floor(times) - day * 24 * 60 * 60 - hour * 60 * 60 - minute * 60
  //       }
  //       if (day <= 9) day = day
  //       if (hour <= 9) hour = '0' + hour
  //       if (minute <= 9) minute = '0' + minute
  //       if (second <= 9) second = '0' + second
  //       let daystr = ''
  //       if (day > 0) {
  //         // daystr = day
  //         daystr = day + 'days '
  //       }
  //       //
  //       this.setState({
  //         time: daystr + hour + ':' + minute + ':' + second
  //       })
  //       times--
  //     }.bind(this),
  //     1000
  //   )
  //   if (times <= 0) {
  //     clearInterval(timer)
  //   }
  // }

  // 每日充值模块
  dailyList = (list, dailyTotal) => {
    let { lang } = this.state
    return (
      <div className="list">
        {
          list.map((item, index) => {
            return (
              <div className="item" key={index}>
                {/* $gold */}
                <div className="title">${item.rechargeAmount / 100}</div>

                {/* 金币图片 */}
                <div className="gold">
                  <img src="/img/activity/recharge/gold.png" />
                </div>

                {/* 金额 */}
                <div className="goldNum">
                  {item.rewardDetail && item.rewardDetail.length > 0 && item.rewardDetail[0].rewardNum}
                </div>

                {/* 是否领取按钮 */}
                {
                  item.alreadyGet == false && item.canGet == true
                    ?
                    (
                      <div className={'get bg1'} onClick={this.getCharge.bind(this, item.id)}>
                        {lang.get}
                      </div>
                    )
                    :
                    (
                      <div className={'get bg2'}>
                        {item.alreadyGet == true
                          ? item.rechargeAmount / 100 + '/' + item.rechargeAmount / 100
                          : dailyTotal + '/' + item.rechargeAmount / 100}
                      </div>
                    )
                }
              </div>
            )
          })
        }
      </div>
    )
  }

  // 月充值模块
  monthList = (monthList, monthlyTotal) => {
    let { lang, language } = this.state
    // console.log(333333333,monthList,monthlyTotal)
    return (
      <div>
        {monthList.map((item, index) => {
          return (
            <div className="box1" key={index}>
              <div className="box1t">
                <span>{lang.monthly} ${item.rechargeAmount / 100}</span>
              </div>
              <div className="box1c">

                {/* 奖励列表 */}
                <div className="list">
                  {
                    item.rewardDetail.map((item2, index2) => {
                      return (
                        <div className="item2" key={index2}>
                          <div className="bg">
                            <img src={item2.rewardType == 'gold' ? '/img/activity/recharge/gold.png' : item2.pic} />
                          </div>
                          <div
                            className="name"
                            style={{ width: `${item2.rechargeLevelId >= 12 ? "5rem" : "2rem"}` }}
                          >
                            {item2.rewardType == 'gold' ? score(item2.rewardNum) : language == 'tr' ? item2.rewardNameTr ||item2.rewardName :language == 'ar' ? item2.rewardNameAr ||item2.rewardName: item2.rewardName}
                          </div>
                        </div>
                      )
                    })
                  }
                </div>

                {/* 是否领取按钮 */}
                {
                  item.alreadyGet == false && item.canGet == true
                    ?
                    (
                      <div className={'get2 bg1'} onClick={this.getCharge.bind(this, item.id)}>
                        Get
                      </div>
                    )
                    :
                    (
                      <div className={'get2 bg2'} onClick={this.getCharge.bind(this, item.id)}>
                        {
                          item.alreadyGet == true
                            ? item.rechargeAmount / 100 + '/' + item.rechargeAmount / 100
                            : monthlyTotal + '/' + item.rechargeAmount / 100
                        }
                      </div>
                    )
                }
              </div>
              <div className="box1b">
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  // 倒计时模块
  // timmer = () => {
  //   let { lang } = this.state
  //   return (
  //     <div className="countdown">
  //       <div className="countdowntitle">
  //         <img className="left" src="/img/activity/recharge/right.png" />
  //         <div className="word">{lang.monthly}</div>
  //         <img className="right" src="/img/activity/recharge/left.png" />
  //       </div>
  //       <div className="timer">
  //         {lang.timeR} {this.state.time}
  //       </div>
  //     </div>
  //   )
  // }

  render() {
    let { language, lang } = this.state
    let { dailyList, monthList, dailyTotal, monthlyTotal, } = this.rechargeStore.data

    return (
      <div className="img750">
        
        <div className="page-recharge">

          {/* 大背景 */}
          <div className="b-bg"></div>

          {/* 每日、每月充值模块 */}
          <div className={`${language == 'tr'?'bgT':language == 'ar'?'bgA':'bgE'}`}>

            {/* banner */}
            <div className="box0"></div>

            {/* 每日充值模块 */}
            <div className="box1 mt">
              <div className="box1t">
                <span>{lang.DailyBenefits}</span>
              </div>
              <div className="box1c">
                {this.dailyList(dailyList, dailyTotal)}
              </div>
              <div className="box1b"></div>
            </div>

            {/* 倒计时模块 */}
            {/* {this.timmer()} */}

            <CountDown lang={this.state.lang} leftTimestamp={this.state.getTime} />

            {/* 每月充值模块 */}
            {this.monthList(monthList, monthlyTotal)}

            {/* <div className="box1">
            <div className="box1t">{lang.DailyBenefits}</div>
            <div className="box1c">
              {this.monthList(monthList)}
            </div>
            <div className="box1b"></div>
          </div> */}

            <Toast
              language={language}
              lang={this.state.lang}
              ref="toast"
              id="toast"
              toastContent={this.state.toastContent}
            />

            {/* 规则页面 */}
            <div className="rules" onClick={this.hideRule.bind(this, true)}>
              {this.state.lang.ruleText}
            </div>

            {/* 加载 */}
            {this.state.ruleStatus && <div className="loading" onClick={this.hideRule.bind(this, false)}></div>}

            {/* 规则弹窗 */}
            {this.state.ruleStatus && (
              <div className={`popRule animationBeBigCenter`} onClick={this.hideRule.bind(this, false)}>
                <div
                  className={`content ${language == 'ar' && 'arlang'}`}
                  dangerouslySetInnerHTML={{ __html: lang.rule }}
                ></div>
              </div>
            )}
          </div>
          {/* 客服 */}
          <div className="service" onClick={jumpToUser.bind(this, 977239)}>
            <span>{lang.service}</span>
          </div>

        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/rechargenew/index.js